var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 16.4164C7.28736 16.4164 7.56291 16.3023 7.76607 16.0991C7.96924 15.896 8.08337 15.6204 8.08337 15.3331V3.8606L11.6475 7.43561C11.7483 7.53714 11.8681 7.61774 12.0001 7.67274C12.1321 7.72774 12.2737 7.75605 12.4167 7.75605C12.5597 7.75605 12.7013 7.72774 12.8333 7.67274C12.9653 7.61774 13.0852 7.53714 13.1859 7.43561C13.2874 7.3349 13.368 7.21508 13.423 7.08306C13.478 6.95105 13.5063 6.80945 13.5063 6.66644C13.5063 6.52343 13.478 6.38183 13.423 6.24981C13.368 6.1178 13.2874 5.99798 13.1859 5.89727L7.76921 0.480604C7.6685 0.379065 7.54868 0.298471 7.41666 0.243472C7.28465 0.188473 7.14305 0.160156 7.00004 0.160156C6.85703 0.160156 6.71543 0.188473 6.58342 0.243472C6.4514 0.298471 6.33158 0.379065 6.23087 0.480604L0.814205 5.89727C0.610209 6.10127 0.495605 6.37795 0.495605 6.66644C0.495605 6.95493 0.610209 7.23161 0.814205 7.43561C1.0182 7.6396 1.29488 7.7542 1.58337 7.7542C1.87187 7.7542 2.14854 7.6396 2.35254 7.43561L5.91671 3.8606V15.3331C5.91671 15.6204 6.03084 15.896 6.23401 16.0991C6.43717 16.3023 6.71272 16.4164 7.00004 16.4164Z",
    fill: "#DF0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.182b05b75aae0718559327a08365e7d9.svg";
export { ForwardRef as ReactComponent };